import {
    BaseService
} from './base.service';
import {
    ErrorWrapper,
    ResponseWrapper
} from './util';

export class ShopWindowsService extends BaseService {
    static get entity() {
        return 'shopWindows';
    }


    static async getCurrent(url) {
        try {
            const response = await this.request({
                auth: true
            }).get(`${process.env.VUE_APP_EAD_API_URL}/shopwindows`, {
                params: {
                    url
                }
            });

            if (response.data != null)
                this.setCurrentShopWindow(response.data);

            return new ResponseWrapper({
                status: 200,
                data: {
                    success: true
                }
            }, response.data);

        } catch (error) {
            const message = error.response?.data && typeof (error.response?.data) === 'object' ? error.response?.data.error : error.message;
            throw new ErrorWrapper(error, message);
        }
    }
    static async getCurrentFullGrid() {
        try {
            var data = this.getCurrentShopWindow();

            // Valida shopWindowId antes de fazer requisição
            if (!this.isValidShopWindowId(data)) {
                // Retorna null ao invés de erro, indicando que não há shopWindow válido
                return new ResponseWrapper({
                    status: 200,
                    data: {
                        success: false
                    }
                }, null);
            }

            const response = await this.request({
                auth: true
            }).get(`${process.env.VUE_APP_EAD_API_URL}/shopwindows/${data}`);

            return new ResponseWrapper({
                status: response.status,
                data: {
                    success: true
                }
            }, response.data);

        } catch (error) {
            const message = error.response?.data && typeof (error.response?.data) === 'object' ? error.response?.data.error : error.message;
            throw new ErrorWrapper(error, message);
        }
    }
    static async getLearningObjectsEnrolls(studentId) {
        try {
            var data = this.getCurrentShopWindow();
            
            // Valida shopWindowId antes de fazer requisição
            if (!this.isValidShopWindowId(data)) {
                // Retorna resposta vazia ao invés de erro, pois não há shopWindowId válido
                return new ResponseWrapper({
                    status: 200,
                    data: {
                        success: true
                    }
                }, []);
            }

            const response = await this.request({
                auth: true
            }).get(`${process.env.VUE_APP_EAD_API_URL}/enrolls/getloids?userMktId=${studentId}&shopWindowId=${data}`);

            return new ResponseWrapper({
                status: response.status,
                data: {
                    success: true
                }
            }, response.data);

        } catch (error) {
            const message = error.response?.data && typeof (error.response?.data) === 'object' ? error.response?.data.error : error.message;
            throw new ErrorWrapper(error, message);
        }
    }
    static setCurrentShopWindow(data) {
        if (data.id) {
            sessionStorage.setItem('shopWindowId', data.id);
        };
    }
    static clearCurrentShopWindow() {
        sessionStorage.removeItem('shopWindowId');
    }
    static getCurrentShopWindow() {
        return sessionStorage.getItem('shopWindowId');
    }
    static isValidShopWindowId(id) {
        return id && 
               id !== 'undefined' && 
               id !== 'null' && 
               id !== undefined && 
               id !== null &&
               id.toString().trim() !== '';
    }
    static tryGetShopWindowIdFromEnrolls(enrolls) {
        // Tenta buscar shopWindowId dos enrolls do usuário como fallback
        if (!enrolls || !Array.isArray(enrolls) || enrolls.length === 0) {
            return null;
        }

        // Procura o primeiro enroll com shopWindowId válido
        const enrollWithShopWindow = enrolls.find(enroll => 
            enroll.shopWindowId && this.isValidShopWindowId(enroll.shopWindowId)
        );

        return enrollWithShopWindow ? enrollWithShopWindow.shopWindowId : null;
    }
}
